module.exports = __webpack_public_path__ + "img/top02.f7bc9a06.gif";